import { render, staticRenderFns } from "./EmptyState.vue?vue&type=template&id=7f04cc3c&"
import script from "./EmptyState.vue?vue&type=script&lang=js&"
export * from "./EmptyState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7f04cc3c')) {
      api.createRecord('7f04cc3c', component.options)
    } else {
      api.reload('7f04cc3c', component.options)
    }
    module.hot.accept("./EmptyState.vue?vue&type=template&id=7f04cc3c&", function () {
      api.rerender('7f04cc3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/EmptyState.vue"
export default component.exports